import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import FullScreenOverlay from '@bibliocommons/base-full-screen-overlay';
import { ExpandableText } from '@bibliocommons/expandable';
import { bibShape, shelfItemShape, userIdentityShape, ugcPrivateNoteShape } from '@bibliocommons/bc-prop-types';

import PrivateNoteUGCEditor from '../UGCEditors/PrivateNoteUGCEditor';
import DisplayWrapper from '../DisplayWrapper';
import DisplayActions from '../DisplayActions';

import './PrivateNoteDisplay.scss';

export default class PrivateNoteDisplay extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('openEditor', 'closeEditor');

    this.state = {
      showEditor: false
    };
  }

  openEditor() {
    this.setState({ showEditor: true });
  }

  closeEditor() {
    this.setState({ showEditor: false });
  }

  renderEditor() {
    return this.state.showEditor && (
      <PrivateNoteUGCEditor
        bib={this.props.bib}
        shelfItem={this.props.shelfItem}
        handleClose={this.closeEditor}
        existingPrivateNote={this.props.privateNote}
        privateNotesTransactions={this.props.privateNotesTransactions}
        shelfTransactions={this.props.shelfTransactions}
        privateNotesActions={this.props.privateNotesActions}
        shelfActions={this.props.shelfActions} />
    );
  }

  renderActions() {
    const { privateNotesActions, privateNotesTransactions, owner, privateNote, bib } = this.props;

    if (owner.get('loggedIn')) {
      const noteId = privateNote.get('id');
      const metadataId = privateNote.get('metadataId');
      const handleRemove = () => privateNotesActions.removePrivateNote({ metadataId, noteId });
      const isRemoving = privateNotesTransactions.getIn([metadataId, noteId, 'isRemoving'], false);
      const title = bib.getIn(['briefInfo', 'title']);
      const editScreenReaderMessage = <FormattedMessage id="ada_ugc_edit_private_note" values={{ title }} />;
      const removeScreenReaderMessage = <FormattedMessage id="ada_ugc_remove_private_note" values={{ title }} />;

      return (
        <DisplayActions
          handleEdit={this.openEditor}
          handleRemove={handleRemove}
          isRemoving={isRemoving}
          editScreenReaderMessage={editScreenReaderMessage}
          removeScreenReaderMessage={removeScreenReaderMessage} />
      );
    }

    return null;
  }

  render() {
    return (
      <DisplayWrapper className="cp-ugc-private-note-display">
        <ExpandableText text={this.props.privateNote.get('note')} />
        {this.renderActions()}

        <FullScreenOverlay open={!!this.state.showEditor} handleClose={this.closeEditor}>
          {this.renderEditor()}
        </FullScreenOverlay>
      </DisplayWrapper>
    );
  }
}

PrivateNoteDisplay.propTypes = {
  bib: bibShape.isRequired,
  shelfItem: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  privateNote: ugcPrivateNoteShape.isRequired,
  privateNotesTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  privateNotesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};



// WEBPACK FOOTER //
// ./app/components/shared/UGC/PrivateNoteDisplay/PrivateNoteDisplay.jsx